import { register } from './viewbilityTracker'

export function registerExternalScripts() {
  register('.thinkjamEmbedded')
  register('.accountantEmbedded')
  register('.deep-itEmbedded')
  register('.top-posts-side-bar__item')
  register('.pluralistEmbedded')
  register('.trivmaniaEmbedded')
  register('.build_legenedEmbedded')
  register('.riddleEmbedded')
  register('.ei_arenaEmbedded')
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/viewability/externalScriptsViewabilityRegistration.js